<template>
  <div class="content-card mb-4">
    <div class="content-card-title d-flex justify-content-between pt-0 pb-0">
      <span>รายได้คงเหลือ</span>
      <h2 class="mb-0 text-primary">฿ {{ (currentIncome)? currentIncome: '0.00' }}</h2>
    </div>
    <div class="content-card-body">
      <label class="form-label">ถอน</label>
      <div class="input-group input-group-merge mb-4">
        <input type="text" class="form-control" placeholder="จำนวนเงินเป็นตัวเลข" v-model="amount" />
        <span class="input-group-text">บาท</span>
      </div>
      <p class="text-medium mb-0">ถอนรายได้ค่าแนะนำ ขั้นต่ำ 500 บาท</p>
      <div class="d-grid">
        <button class="btn btn-primary btn-xl" @click="submit()">ถอนรายได้</button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  // inquiryBalanceAffiliateService,
  withdrawalAffiliateService,
  inquiryStagementAffiliateService,
  affiliateOverallService
} from '@/services'
import { mapActions, mapState } from 'vuex'
// import JwPagination from 'jw-vue-pagination'
import moment from 'moment'
export default {
  props: {
    getCurrentIncome: {
      type: String,
      default: '0.00'
    }
  },
  data () {
    return {
      totalIncomeBalance: '0.00',
      lastUpdateDate: moment(),
      amount: null,
      historyStageAf: null,
      pageOfItems: []
    }
  },
  computed: {
    ...mapState({
      currentIncome: (state) => state.affiliateModule.currentIncome
    })
  },
  methods: {
    ...mapActions(['setLoading']),
    numberWithCommas (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    async submit () {
      if (this.amount > 0) {
        this.setLoading(true)
        await withdrawalAffiliateService(this.amount)
        const resp = await affiliateOverallService()
        if (resp.status_code === 'SUCCESS') {
          this.totalIncomeBalance = resp.data.currentIncome
        }
        this.setLoading(false)
      }
    }
  },
  async mounted () {
    this.totalIncomeBalance = this.getCurrentIncome
    await affiliateOverallService()
    const resp = await inquiryStagementAffiliateService()
    if (resp.status_code === 'SUCCESS') {
      this.historyStageAf = resp.data
    }
  }
}
</script>
